import { useEntityFinderContext } from "../context/EntityFinderContext";
import { User } from "@/bryntum-lib/models/User";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";
import { BoardUser, UserAvatar } from "@/modern/components/user-avatar";

export const UserTab = () => {
  const { data, handleClose } = useEntityFinderContext();
  const { editorHandler } = useSwivuBryntumContext();
  const users = data as User[];

  const handleUserClick = (user: User) => {
    // @ts-expect-error openEditor is not in the type definition
    editorHandler.openEditor(EDITOR_KEYS.userEditor, user, { user });
    handleClose();
  };

  return (
    <div className="flex flex-col h-full overflow-auto bg-background">
      {users.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-muted-foreground p-8 text-center">
          <svg className="w-12 h-12 mb-4 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <p className="text-sm">No users found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {users.map((user, index) => (
            <div
              key={user.id}
              onClick={() => handleUserClick(user)}
              className={`px-4 py-3 bg-card hover:opacity-90 cursor-pointer transition-all border-b border-border/40 last:border-b-0 rounded-md ${index === 0 ? "border-t-0" : ""}`}
            >
              {user.name && <UserAvatar user={user as unknown as BoardUser} size="default" showName={true} showTooltip={false} />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
